const checkedModifier = "dibc1c1oadh";
const toggle = "dibt1hc54m0";

export { checkedModifier, toggle };
import "./switch.styles.linaria.module.css";
//# sourceMappingURL=switch.styles.js.map
